<topo-modal
  [isActive]="isActive"
  [backgroundCanClose]="backgroundCanClose"
  [isCard]="true"
  (close)="cancelClick()"
  [width]="1024"
  [headerIsFullWidth]="true">
  <div class="modal-header">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="mx-4">
      <h5 class="mx-4 my-4">{{ title }}</h5>
      <div
        class="dialog-close"
        (click)="cancelClick()">
        <i class="icon icon-close-X"></i>
      </div>
    </div>
  </div>

  <div class="modal-body">
    <quill-editor
      [styles]="{ height: '300px' }"
      placeholder=""
      [modules]="editorModules"
      [(ngModel)]="htmlValue"
      (onEditorCreated)="editorCreated($event)"></quill-editor>
  </div>

  <div class="modal-footer">
    <div
      fxLayout="row"
      fxLayoutAlign="end"
      class="mt-4 mb-4">
      <div style="margin-right: 5px">
        <button
          class="button is-secondary"
          (click)="cancelClick()">
          {{ 'MAP.CANCEL' | translate }}
        </button>
      </div>
      <div>
        <button
          class="button is-primary"
          (click)="saveClick()">
          {{ 'MAP.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</topo-modal>
